export type StationStatus = "AVAILABLE" | "DISABLED" | "MAINTENANCE" | "ACTIVATED";
export interface Station {
  station_id: string;
  station_location_lng: number;
  station_location_lat: number;
  station_name: string;
  station_street: string;
  station_zip_code: string;
  station_city: string;
  station_country: string;
  station_hardware_id: string;
  station_created_at: string;
  station_updated_at: string;
  station_organization_id: string;
  station_created_by: string;
  station_status: StationStatus;
  station_slug: string;
 station_thumbnail_image_file_id: string;
}

export type StationPatch = Partial<Omit<Station, "station_id">>;

export interface ChargePoint {
  charge_point_id: string,
  charge_point_station: string,
  charge_point_hardware_id: string ,
  charge_point_name:string ,
  charge_point_organization_id: string,
  charge_point_created_at: string,
  charge_point_updated_at: string,
  charge_point_created_by: string
  charge_point_firmware_version: string
}

export type ChargePointPatch = Partial<Omit<ChargePoint, "e_borne_id">>;

export type ConnectorType = "Type2"| "CCS2"| "GB/T" | "E/F"
export interface BConnector {
  b_connector_id: string,
  b_connector_charge_point: string,
  b_connector_number: string,
  b_connector_type: ConnectorType,
  b_connector_organization_id: string ,
  b_connector_hardware_id: string ,
  b_connector_created_at: string,
  b_connector_updated_at: string,
  b_connector_created_by: string,
  b_connector_price_per_kwh: number,
  b_connector_price_currency: string,
  b_connector_slug: string,
  b_connector_tag_id: number
  station_id: string
  station_slug: string
  station_hardware_id: string
  b_connector_max_power_kw: number,
}

export type BConnectorPatch = Partial<Omit<BConnector, "b_connector_id">>;

export const  translateStationStatus = (status: StationStatus): string => {
  switch(status){
    case "AVAILABLE":
      return "Disponible"
    case "DISABLED":
      return "Désactivé"
    case "MAINTENANCE":
      return "En maintenance"
    case "ACTIVATED":
      return "Activé"
  }
}